var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495.39789 461.3044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487.083,225.514l-75.08-75.08V63.704a28.395,28.395,0,0,0-56.79,0V93.645L299.31,37.74c-27.639-27.624-75.694-27.575-103.27.05L8.312,225.514a28.40094,28.40094,0,0,0,40.172,40.158L236.194,77.943c6.115-6.083,16.893-6.083,22.976-.018L446.912,265.672a28.40058,28.40058,0,1,0,40.171-40.158Z",
    transform: "translate(-0.0005 -17.04661)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.561,131.836a13.93783,13.93783,0,0,0-19.723,0L72.712,296.913a13.97679,13.97679,0,0,0-4.085,9.877V427.191a51.16306,51.16306,0,0,0,51.16,51.16h81.754V351.741H293.84v126.61h81.755a51.16263,51.16263,0,0,0,51.159-51.159V306.79a13.92235,13.92235,0,0,0-4.085-9.877Z",
    transform: "translate(-0.0005 -17.04661)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIc);
export default __webpack_public_path__ + "static/media/home-ic.3999c34033d021ae8138970221fd702a.svg";
export { ForwardRef as ReactComponent };